"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsvExportFolder = void 0;
var getCsvExportFolder = function (landscape, tenantId, formatId) {
    return "".concat(landscape, "/").concat(tenantId, "/csv-export/").concat(formatId);
};
exports.getCsvExportFolder = getCsvExportFolder;
